/* eslint-disable max-lines */
import { css } from 'linaria';
import { styled } from 'linaria/react';

type StyledNewKitchenCategoriesGridProps = {
  categoriesNumber: number;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLUListElement>, HTMLUListElement>;

export const newKitchenCategoriesSectionTabs = css`
  margin-bottom: 24px;

  @media (--only-mobile) {
    margin-bottom: 32px;
  }
`;

export const StyledNewKitchenCategoriesGrid = styled.ul<StyledNewKitchenCategoriesGridProps>`
  display: grid;
  padding: 0;
  margin: 0;
  column-gap: 12px;
  list-style: none;
  row-gap: 12px;

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 16px;
  }
`;

export const newKitchenCategoriesGridStylesMap: Record<number, string> = {
  2: css`
    @media (--from-tablet) {
      grid-template-columns: repeat(2, 1fr);
    }
  `,
  5: css`
    @media (--only-largeDesktop) {
      grid-template-columns: repeat(5, 1fr);
    }

    @media (--only-desktop) {
      grid-template-columns: 305px 147px 147px 305px;

      li:nth-child(2),
      li:nth-child(1),
      li:nth-child(4) {
        grid-column-start: span 2;
      }
    }

    @media (--only-tablet) {
      grid-template-columns: 212px 100px 100px 212px;

      li:nth-child(2),
      li:nth-child(1),
      li:nth-child(4) {
        grid-column-start: span 2;
      }
    }
  `,
  7: css`
    @media (--from-desktop) {
      grid-template-columns: 286px 87px 187px 187px 87px 286px;

      li:nth-child(2),
      li:nth-child(3),
      li:nth-child(5),
      li:nth-child(6),
      li:nth-child(1) {
        grid-column-start: span 2;
      }
    }

    @media (--only-desktop) {
      grid-template-columns: 226px 67px 147px 147px 67px 226px;
    }

    @media (--only-tablet) {
      grid-template-columns: 212px 100px 100px 212px;

      li:nth-child(6),
      li:nth-child(-n + 4) {
        grid-column-start: span 2;
      }
    }
  `,
  10: css`
    @media (--only-largeDesktop) {
      grid-template-columns: repeat(5, 1fr);
    }

    @media (--only-desktop) {
      grid-template-columns: 226px 67px 147px 147px 67px 226px;

      li:nth-child(8),
      li:nth-child(9),
      li:nth-child(-n + 6) {
        grid-column-start: span 2;
      }
    }

    @media (--only-tablet) {
      grid-template-columns: 212px 100px 100px 212px;

      li:nth-child(-n + 4),
      li:nth-child(6),
      li:nth-child(9) {
        grid-column-start: span 2;
      }
    }
  `,
  11: css`
    @media (--only-largeDesktop) {
      grid-template-columns: 226px 147px 68px 226px 68px 147px 226px;

      li:nth-child(3),
      li:nth-child(2n + 4),
      li:nth-child(1) {
        grid-column-start: span 2;
      }

      li:nth-child(5),
      li:nth-child(2) {
        grid-column-start: span 3;
      }
    }

    @media (--only-desktop) {
      grid-template-columns: 226px 67px 147px 147px 67px 226px;

      li:nth-child(5),
      li:nth-child(6),
      li:nth-child(9),
      li:nth-child(10),
      li:nth-child(-n + 3) {
        grid-column-start: span 2;
      }
    }

    @media (--only-tablet) {
      grid-template-columns: 212px 100px 100px 212px;

      li:nth-child(2),
      li:nth-child(3n + 4),
      li:nth-child(1) {
        grid-column-start: span 2;
      }
    }
  `,
  18: css`
    @media (--only-largeDesktop) {
      grid-template-columns: 226px 48px 166px 108px 108px 166px 48px 226px;

      li:nth-child(10),
      li:nth-child(11),
      li:nth-child(12),
      li:nth-child(15),
      li:nth-child(16),
      li:nth-child(17),
      li:nth-child(-n + 8) {
        grid-column-start: span 2;
      }
    }

    @media (--only-desktop) {
      grid-template-columns: 226px 67px 147px 147px 67px 226px;

      li:nth-child(8),
      li:nth-child(9),
      li:nth-child(12),
      li:nth-child(13),
      li:nth-child(16),
      li:nth-child(17),
      li:nth-child(-n + 6) {
        grid-column-start: span 2;
      }
    }

    @media (--only-tablet) {
      grid-template-columns: repeat(3, 212px);
    }
  `,
};

export const newKitchenCategoriesSectionItem = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-top: 16px;
  background-color: rgb(46 50 61 / 5%);
  border-radius: var(--rounding-m);

  @media (--only-mobile) {
    flex-direction: row;
    padding-top: 0;
    padding-right: 16px;
    column-gap: 16px;
    background-color: transparent;
    border-radius: 0;
  }

  &:hover {
    p {
      color: var(--brand-dark);
    }
  }
`;

export const newKitchenCategoriesSectionItemImageWrapper = css`
  @media (--only-mobile) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    background-color: rgb(46 50 61 / 5%);
    border-radius: var(--rounding-m);
  }
`;

export const newKitchenCategoriesSectionItemImage = css`
  display: block;

  @media (--only-mobile) {
    width: 48px;
    height: 48px;
  }
`;

export const newKitchenCategoriesSectionItemName = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 68px;
  padding: 0 16px;
  padding-bottom: 4px;
  text-align: center;

  @media (--only-mobile) {
    display: block;
    height: auto;
    padding: 0;
    text-align: left;
  }
`;
